import React from "react"
import styled from "styled-components"
import { get, findIndex, isUndefined } from "lodash"
import { Upload as AntdUpload, Icon } from "antd"
import { media } from "../../../../components/mediaStyles"
import { colors } from "../../../../components/Color"
import Question from "../Question"
import { Form } from "antd"
import CheckIcon from "../CheckIcon"
import ErrorIcon from "../ErrorIcon"
import Text from "../../../../components/Text/Text"
import Title from "../../../../components/Text/Title"

const Section = styled.div`
  text-align: center;
  font-family: GT America, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 500px;
`

const WarningRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  color: red !important;
  font-size: 16px;
  padding-bottom: 10px;
`

const TextIcon = styled.div`
  font-family: Recife Text, serif;
  font-weight: 700;
  font-size: 20px;
`

const UploadedFiles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;

  ${media.tablet`
    // max-width: 400px;
  `}
`

const FormItem = styled(Form.Item)`
  position: relative;
  width: 100%;

  .ant-form-explain {
    font-family: GT America, sans-serif;
    position: absolute !important;
    bottom: -25px !important;
  }
`

const UploadRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  > * {
    width: 100%;
  }
`

export default class Upload extends React.Component {
  state = {
    percentage: 0,
    fileList: this.props.value || [],
    uploading: false,
  }

  componentDidUpdate() {
    if (
      get(this.props, "value", []).length > 0 &&
      this.state.fileList.length === 0
    ) {
      this.setState({
        fileList: this.props.value,
      })
    }
  }

  render() {
    const { question, getFieldDecorator } = this.props

    return (
      <Section>
        <Question {...this.props.question} />
        <WarningRow>Uploads größer als 100 MB werden nicht akzeptiert</WarningRow>
        {getFieldDecorator && (
          <FormItem>
            {getFieldDecorator(question.identifier, {
              initialValue: this.props.value,
              rules: [
                {
                  required: this.props.question.required,
                  message: "Bitte ausfüllen",
                },
              ],
              trigger: "valueChanged",
            })(
              <InputFieldWrapper
                placeholder={this.props.placeholder}
                onPressEnter={event => {
                  event.preventDefault()
                  this.props.onSubmit(this.props.question.identifier)
                }}
                innerRef={inputField => {
                  this.input = inputField
                }}
                prefix={<TextIcon>T</TextIcon>}
                suffix={
                  this.state.isValid != null ? (
                    this.state.isValid ? (
                      <CheckIcon />
                    ) : (
                      <ErrorIcon />
                    )
                  ) : (
                    <span />
                  )
                }
              />
            )}
          </FormItem>
        )}
      </Section>
    )
  }
}

class InputFieldWrapper extends React.Component {
  state = {
    fileList: this.props.value || [],
    uploading: false,
  }

  onRemove = file => {
    this.setState(
      state => {
        const index = findIndex(state.fileList, { file })
        const newFileList = state.fileList.slice()
        newFileList.splice(index, 1)

        return {
          fileList: newFileList,
        }
      },
      () => {
        this.props.valueChanged([...this.state.fileList])
      }
    )
  }
  beforeUpload = file => {
    console.log("Before Uplaod", file, this.state.fileList.length)
    this.setState(
      state => ({
        fileList: [...state.fileList, { file }],
      }),
      () => this.props.valueChanged(this.state.fileList)
    )
    return false
  }

  render() {
    return (
      <React.Fragment>
        <UploadRow>
          <AntdUpload.Dragger
            name="file"
            multiple={true}
            fileList={this.state.fileList
              .map(({ file }) => file)
              .filter(file => file)}
            onRemove={this.onRemove}
            beforeUpload={this.beforeUpload}
          >
            <p className="ant-upload-drag-icon">
              <Icon name="upload" style={{ color: colors.teal }} />
            </p>
            <p className="ant-upload-text">
              Zum hochladen klicken oder Datei hierhin ziehen.
            </p>
            <p className="ant-upload-hint">
              Es können ein oder mehrere Dateien hochgeladen werden
            </p>
          </AntdUpload.Dragger>
        </UploadRow>
        {this.state.fileList.filter(({ file }) => isUndefined(file)).length >
          0 && (
          <UploadedFiles>
            <Title size="small">Bereits hochgeladen</Title>
            {this.state.fileList
              .filter(({ file }) => isUndefined(file))
              .map(({ name }) => (
                <Text size="normal">{name}</Text>
              ))}
          </UploadedFiles>
        )}
      </React.Fragment>
    )
  }
}
